import React, { MouseEventHandler, useEffect, useState } from 'react';

import { RefreshCcw } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/shadcn/ui/dialog';
import useBuildInfoStore from '@/hooks/useBuildInfo';

const BuildChangeAlert: React.FC = () => {
  const { buildInfo } = useBuildInfoStore();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!buildInfo?.build) {
      return;
    }
    const storedBuild = sessionStorage.getItem('cwapAppBuild');

    if (!storedBuild) {
      sessionStorage.setItem('cwapAppBuild', buildInfo.build);
    } else if (storedBuild !== buildInfo.build) {
      setIsOpen(true);
    }
  }, [buildInfo?.build]);

  const onReloadHandler: MouseEventHandler = (e) => {
    e.stopPropagation();
    sessionStorage.removeItem('cwapAppBuild');
    window.location.reload();
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => null}>
      <DialogContent hideClose className="max-w-xl">
        <DialogHeader>
          <DialogTitle>App version has been updated</DialogTitle>
          <DialogDescription>You must reload the page in order to operate on the latest version!</DialogDescription>
        </DialogHeader>

        <div className="my-4">
          It is fundamentally important to operate on the latest version, as smart contracts may have changed.
        </div>

        <Button onClick={onReloadHandler}>
          <RefreshCcw size={16} strokeWidth={2.5} className="mr-2" />
          Reload
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default BuildChangeAlert;
